module.exports = __webpack_public_path__ + "img/photo-01.3dbba147.jpg";